// export deep clone function
// export const deepClone = (obj: object) => JSON.parse(JSON.stringify(obj));
export const deepClone = (obj: {}) => JSON.parse(JSON.stringify(obj));
